import { useEffect } from 'react';
import { isNil } from 'lodash';
import {
  getLTSocialAuthConfig,
  initSocialNetworkHandlers,
} from '../utils/socialNetworkUtils';

/**
 * @desc хук для инициализации скриптов SDK социальных сетей.
 * */
export const useInitSocialNetworkHandlers = (): void => {
  const authConfig = getLTSocialAuthConfig();

  useEffect(() => {
    if (!isNil(authConfig)) {
      initSocialNetworkHandlers(authConfig);
    }
  }, [authConfig]);
};
